import { render } from "./App.vue?vue&type=template&id=03460456"
const script = {}

import "./App.vue?vue&type=style&index=0&id=03460456&lang=less"

import exportComponent from "E:\\vue\\28-元宇宙未来智慧城\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__